import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { EllipsisTooltipComponent } from '@shared/components';
import { DashboardExpiringSamplesColumnEnum } from 'src/app/features/dashboard/_core/enums';
import { DashboardTableColumn } from 'src/app/features/dashboard/_core/interfaces';
import { DashboardExpiringSample } from 'src/app/features/dashboard/_core/interfaces/dashboard-expired-sample.interface';

@Component({
    selector: '[app-expiring-samples-table-row]',
    standalone: true,
    imports: [EllipsisTooltipComponent, DatePipe],
    templateUrl: './expiring-samples-table-row.component.html',
    styleUrls: ['./expiring-samples-table-row.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpiringSamplesTableRowComponent {
    readonly columns = input.required<DashboardTableColumn<DashboardExpiringSamplesColumnEnum>[]>();
    readonly sample = input.required<DashboardExpiringSample>();

    readonly dashboardExpiringSamplesColumnsEnum = DashboardExpiringSamplesColumnEnum;
}
